module.exports = __webpack_public_path__ + "ci.a58e55f4aba096068d44.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/ci.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/ci.svg
// module chunks = styles